export const NOTIFY_SUCCESS = 'NOTIFY_SUCCESS';
export const NOTIFY_ERROR = 'NOTIFY_ERROR';

export const ROOT_NOTIFY_SUCCESS = 'ROOT_NOTIFY_SUCCESS';
export const ROOT_NOTIFY_ERROR = 'ROOT_NOTIFY_ERROR';




// WEBPACK FOOTER //
// ./src/Notification/constants.js